var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 330,
    height: 33,
    viewBox: "0 0 330 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.823 31.7054L148.195 24.4319H144.66L142.333 31.7054M329 31.7054H182.758V1H174.973L163.563 12.5088L168.664 17.9869L173.72 12.831V31.7054H151.506L153.832 24.4319H158.038L159.56 19.414H155.488L157.457 13.3374H161.528L163.005 8.36561H159.067L161.483 1H155.801L153.43 8.36561H149.94L152.311 1H146.629L144.257 8.36561H140.23L138.709 13.3374H142.602L140.678 19.414H136.74L135.174 24.4319H139.022L136.651 31.7054H1M149.805 19.414L151.774 13.3374H148.284L146.36 19.414H149.805Z",
    stroke: "url(#paint0_linear_3335_1897)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3335_1897",
    x1: 1,
    y1: 16.3527,
    x2: 329,
    y2: 16.3527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#009DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#BC15FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC15FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMobile);
export default __webpack_public_path__ + "static/media/icon-mobile.239d8f9c62ebe4bb010a491d8456be09.svg";
export { ForwardRef as ReactComponent };